import { combineReducers } from 'redux';
import currentUser from './userReducer';
import appBarState from './appBarReducer';
import companies from './companiesReducer';
import realtors from './realtorsReducer';
import notifications from './notificationsReducer';
import communities from './communitiesReducer';
import regions from './regionsReducer';
import rewards from './rewardsReducer';
import users from './usersReducer';
import onHoldPoints from './onHoldPointsReducer';
import clientRegistrations from './clientRegistrationsReducer';
import points from './pointsReducer';
import myPoints from './myPointsReducer';
import mySubmittedPoints from './mySubmittedPointsReducer';
import registration from './registrationReducer';
import apiStatus from "./apiStatusReducer";
import autoNotifications from './autoNotificationReducer'
import bonusLevelState from './bonusLevelReducer'
import events from './eventsReducer'

const rootReducer = combineReducers({
    currentUser, 
    appBarState,
    companies,
    realtors,
    notifications,
    communities,
    regions,
    rewards,
    users,
    onHoldPoints,
    clientRegistrations,
    points,
    myPoints,
    mySubmittedPoints,
    registration,
    apiStatus,
    autoNotifications,
    bonusLevelState,
    events,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js